import { render, staticRenderFns } from "./Carbon.vue?vue&type=template&id=980927c0&scoped=true&"
import script from "./Carbon.vue?vue&type=script&lang=js&"
export * from "./Carbon.vue?vue&type=script&lang=js&"
import style0 from "./Carbon.vue?vue&type=style&index=0&id=980927c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980927c0",
  null
  
)

export default component.exports